const ConfigProps = {
  DisplayAddressWhileShopping: "Display Address While Shopping",
  EnableSinglePageCheckout: "Enable Single Page Checkout",
  OI_Permission_ID: "OI Permission ID",
  Use_Punchout: "Use Punchout",
  View_Reports: "View Reports",
  Manage_Users: "Manage Users",
  Manage_Groups: "Manage Groups",
  Manage_Shipping_Addresses: "Manage Shipping Addresses",
  Manage_Personal_Credit_Card: "Manage Personal Credit Card",
  Manage_Account_Credit_Card: "Manage Account Credit Card",
  Manage_Personal_Checking: "Manage Personal Checking",
  View_Budgets_Page: "View Budgets Page",
  Manage_Order_Approval: "Manage Order Approval",
  Permit_Online_Returns: "Permit Online Returns",
  Display_Save_Cart_Links: "Display Save Cart Links",
  CustomerServicePhoneNumber: "Customer Service Phone Number",
  DisplayGsaLink: "Display GSA Link",
  GsaLinkText: "GSA Link Text",
  DisplayAccountNameOnMasterPage: "Display Account Name on Master Page",
  CustomLogo: "Custom Logo",
  DeliveryStatusEndpoint: "Delivery Status Endpoint",
  DisplayBudgetDetailsWhileShopping: "Display Budget Details While Shopping",
  DisplayShoppingCartAddress: "Display Shopping Cart Address",
  CafeXID: "CafeX ID",
  EnableCafeXWebChat: "Enable CafeX Web Chat",
  EnableAllSalesFinal: "Enable All Sales Final",
  HeaderEmbeddedWebChatID: "Header Embedded Web Chat ID",
  ShowAvailableBudget: "Show Available Budget",
  DefaultARRepImage: "Default AR Rep Image",
  UseDefaultFavoritesList: "Use Default Favorites List",
  DisplayAccountCenterDashboardLink: "Display Account Center Dashboard Link",
  DisplayRecentlyViewedLink: "Display Recently Viewed Link",
  ManageRecurringPayments: "Manage Recurring Payments",
  EnableMyWBRecentItemsPage: "Enable My WB Recent Items Page",
  ManageShippingAddresses: "Manage Shipping Addresses",
  DisplayOrderHistoryLink: "Display Order History Link",
  EnableDashboard: "Enable Dashboard",
  NoImageAvailableImage: "No Image Available Image",
  DisplayQuickOrderLinks: "Display Quick Order Links",
  ProductAvailabilityAPIName: "Product Availability API Name",
  DisplayAvailabilityServiceMessage: "Display Availability Service Message",
  SaveUserSearches: "Save User Searches",
  EnableTypeAhead: "Enable Type Ahead",
  displayDashboard: "Display Dashboard",
  UseExternalIdentityProvider: "Use External Identity Provider",
  DisplayDepartmentDropdown: "Display Department Dropdown",
  DisplayRestrictedItemPrice: "Display Restricted Item Price",
  PreventCheckoutMessage: "Prevent Checkout Message",
  DefaultSortOrderSearch: "Default Sort Order Search",
  EnableResponsiveSearchResults: "Enable Responsive Search Results",
  ManageGroupLists: "Manage Group Lists",
  ManageRestrictions: "Manage Restrictions",
  ListAssignmentRenameExclusion: "List Assignment Rename - Exclusion",
  ListAssignmentRenameInclusion: "List Assignment Rename - Inclusion",
  ListAssignmentRenameReInclusion: "List Assignment Rename - Re-Inclusion",
  DisplayCloseButtonOnSupercedesPopup:
    "Display Close Button On Supercedes Popup",
  EnableSkuGroupAddToCart: "Enable Sku Group Add to Cart",
  AllSalesFinalText: "All Sales Final Text",
  DisplayListPrice: "Display List Price",
  CouponCustomerLimitMessage: "Coupon Customer Limit Message",
  CouponQtyLimitMessage: "Coupon Qty Limit Message",
  RestrictedLink: "Restricted Link",
  RestrictedMessage: "Restricted Message",
  DisplayRelevanceScore: "Display Relevance Score",
  DisplayIndividualUnitPrice: "Display Individual Unit Price",
  QuantityLimitMessage: "Quantity Limit Message",
  UsePunchout: "Use Punchout",
  EnableGroupByTracker: "Enable GroupBy Tracker",
  GroupByArea: "GroupBy Area",
  GroupByCustomerID: "GroupBy Customer ID",
  EnableGroupBySearch: "Enable GroupBy Search",
  GroupByCollection: "GroupBy Collection",
  EnableSEOContentInProductURLs: "Enable SEO Content in Product URLs",
  ActivateAdobeTargetDIVTagSafeZones:
    "Activate Adobe Target DIV Tag Safe Zones",
  DisplayAddToCartPromoItems: "Display Add to Cart Promo Items",
  QuantityMaxDigits: "Quantity Max Digits",
  DisplayAvailability: "Display Availability",
  ActivateAdobeAddToCartPromoItems: "Activate Adobe Add To Cart Promo Items",
  EditBillingAddress: "Edit Billing Address",
  EnableResponsiveShopByItemNumber: "Enable Responsive Shop By Item Number",
  EnableResponsiveShoppingCart: "Enable Responsive Shopping Cart",
  DisplayRegisterLink: "Display Register Link",
  DisplayAddtoCartPopup: "Display Add to Cart Popup",
  EnableOptionalChildLines: "Enable Optional Child Lines",
  EnableResponsiveManageAddresses: "Enable Responsive Manage Addresses",
  EnableResponsiveMyLists: "Enable Responsive My Lists",
  EnableResponsiveAccountCenter: "Enable Responsive Account Center",
  EnableDnBCall: "Enable DnB Call",
  EnableAccountAndSettingsLink: "Enable Account and Settings Link",
  EnableResponsiveAccountDashboard: "Enable Responsive Account Dashboard",
};

export default ConfigProps;
